import React from 'react';
import { func, node, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import { BackLink } from './styles';
import { Chip } from '../../../../components';

const ApplicationHeader = ({
  heading,
  tag,
  subpageHeading,
  backLink,
  description,
  rightSideContent,
}) => {
  return (
    <Box marginBottom={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={1.5}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            {subpageHeading && (backLink.path || backLink.onClick) ? (
              <React.Fragment>
                <BackLink>
                  {backLink.path ? (
                    <Link to={backLink.path} onClick={backLink.onClick}>
                      <Typography variant="h1" marginRight={1}>
                        {heading}
                      </Typography>
                    </Link>
                  ) : (
                    <Button onClick={backLink.onClick}>
                      <Typography variant="h1" marginRight={1}>
                        {heading}
                      </Typography>
                    </Button>
                  )}
                </BackLink>
                <ChevronRightRoundedIcon fontSize="small" />
                <Typography variant="h1" component="span" marginLeft={1}>{subpageHeading}</Typography>
              </React.Fragment>
            ) : (
              <Typography variant="h1">
                {heading}
              </Typography>
            )}
            {tag && (
              <Box marginLeft={1}>
                <Chip label={tag} />
              </Box>
            )}
          </Box>
        </Box>
        {rightSideContent}
      </Box>
      {description && (
        <Typography variant="body1" sx={{ maxWidth: '800px' }}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default ApplicationHeader;

ApplicationHeader.propTypes = {
  backLink: shape({
    path: string,
    onClick: func,
  }),
  heading: string.isRequired,
  tag: string,
  subpageHeading: string,
  description: string,
  rightSideContent: node,
};

ApplicationHeader.defaultProps = {
  tag: null,
  description: null,
  subpageHeading: null,
  backLink: null,
  rightSideContent: null,
};
